import { EditIcon, IconButton, TrashIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SmsTemplatesViewMode } from '../config';

type SmsTemplateListControlsProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  viewMode: SmsTemplatesViewMode;
  onViewModeChange: (mode: SmsTemplatesViewMode) => void;
  filteredCount: number;
  totalCount: number;
  onEditHub: () => void;
  onDeleteHub: () => void;
  isEditHubDisabled?: boolean;
  isDeleteHubDisabled?: boolean;
};

export const SmsTemplateListControls: FC<SmsTemplateListControlsProps> = ({
  searchValue,
  onSearchChange,
  viewMode,
  onViewModeChange,
  filteredCount,
  totalCount,
  onEditHub,
  onDeleteHub,
  isEditHubDisabled,
  isDeleteHubDisabled,
}) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='space-y-3 rounded-2xl border border-secondary-border bg-white p-4'>
      <div className='flex items-center justify-between gap-3'>
        <p className='text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('smsWorkspace.templates.templateControls')}</p>
        <p className='text-sm text-secondary-600'>
          {filteredCount} of {totalCount}
        </p>
      </div>
      <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <input
          type='text'
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={t('smsWorkspace.templates.searchPlaceholder')}
          className='bg-white text-secondary-500 h-10 w-full rounded-lg border border-secondary-border px-3 text-sm focus:outline-none sm:max-w-[280px]'
        />
        <div className='flex flex-wrap items-center gap-2'>
          <button
            type='button'
            onClick={() => onViewModeChange('cards')}
            className={twMerge(
              'h-9 rounded-lg border px-3 text-xs font-semibold uppercase tracking-[0.12em] border-secondary-border bg-white text-secondary-600',
              viewMode === 'cards' && 'border-blue-900 bg-blue-50 text-blue-800'
            )}
          >
            {t('smsWorkspace.templates.cardsView')}
          </button>
          <button
            type='button'
            onClick={() => onViewModeChange('table')}
            className={twMerge(
              'h-9 rounded-lg border px-3 text-xs font-semibold uppercase tracking-[0.12em] border-secondary-border bg-white text-secondary-600',
              viewMode === 'table' && 'border-blue-900 bg-blue-50 text-blue-800'
            )}
          >
            {t('smsWorkspace.templates.tableView')}
          </button>
          <IconButton
            type='button'
            intent='secondary'
            className='!h-9'
            leadingIcon={<EditIcon className='size-4' />}
            onClick={onEditHub}
            disabled={isEditHubDisabled}
            text={t('smsWorkspace.templates.editTemplatesHub')}
          />
          <IconButton
            type='button'
            intent='secondary'
            className='!h-9'
            leadingIcon={<TrashIcon className='size-4' />}
            onClick={onDeleteHub}
            disabled={isDeleteHubDisabled}
            text={t('smsWorkspace.templates.deleteTemplatesHub')}
          />
        </div>
      </div>
    </div>
  );
};
